(function () {
    try {
      /* main variables */
      var debug = 0;
      var variation_name = "";
      var $;
      
      /* all Pure helper functions */
      function waitForElement(selector, trigger, delayInterval, delayTimeout) {
        var interval = setInterval(function () {
          if (
            document &&
            document.querySelector(selector) &&
            document.querySelectorAll(selector).length > 0
          ) {
            clearInterval(interval);
            trigger();
          }
        }, delayInterval);
        setTimeout(function () {
          clearInterval(interval);
        }, delayTimeout);
      }
  
      conditionSection=
        `<section id="eg-nail-care-section">
          <h2>Stop met worstelen met hardnekkige nagelaandoeningen</h2>
          <p>Aanbevolen om symptomen van verschillende moeilijk te behandelen en resistente nagelaandoeningen te verlichten.</p>
          <div class="eg-nail-care-container">
            <table class="eg-nail-care-table">
              <thead>
                <tr>
                  <th>Schimmelprobleem</th>
                  <th>Hoe de Nagelverzorgingspen helpt</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Verkleurde Nagels</td>
                  <td>Breng een gezonde nagelglans terug</td>
                </tr>
                <tr>
                  <td>Witte Vlekken</td>
                  <td>Helpt heldere en vlekkeloze nagels te bereiken</td>
                </tr>
                <tr>
                  <td>Gele Nagels</td>
                  <td>Herstel de heldere, natuurlijke nagelkleur</td>
                </tr>
                <tr>
                  <td>Gebarsten of Broze Nagels</td>
                  <td>Versterk en bescherm fragiele nagels</td>
                </tr>
                <tr>
                  <td>Zwakke Nagels</td>
                  <td>Verhoog sterkte en flexibiliteit om breken te voorkomen</td>
                </tr>
                <tr>
                  <td>Strepen</td>
                  <td>Egaliseer opvallende strepen</td>
                </tr>
                <tr>
                  <td>Lijnen op Nagels</td>
                  <td>Herstelt een egale, gezonde nageltint</td>
                </tr>
                <tr>
                  <td>Losse Nagels</td>
                  <td>Versterk losse nagels</td>
                </tr>
                <tr>
                  <td>Ingedrukte Nagels</td>
                  <td>Helpt oneffen oppervlakken te herstellen voor een gepolijste uitstraling</td>
                </tr>
                <tr>
                  <td>Dikke Teennagels</td>
                  <td>Verminder de dikte voor gemakkelijker knippen</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>`;
  
      function init() {
        document.body.classList.add('AB005');
        const bundleSection=document.querySelector('#__pf [data-pf-type="Layout"]>div:first-child');
        if(bundleSection &&!document.querySelector('#eg-nail-care-section')){
          bundleSection.insertAdjacentHTML('afterend', conditionSection);
        }
  
        document.getElementById("eg-scroll-cta").addEventListener("click", function () {
          const targetSection = document.querySelector('#__pf [data-pf-type="Layout"]>div:first-child .pf-product-form>div:nth-of-type(3)');
          if (targetSection) {
            targetSection.scrollIntoView({ behavior: "smooth" });
          }
        });
      }
  
      /* Initialize variation */
      if (window.location.pathname === '/products/nagelverzorgingspen') {
          waitForElement('#__pf [data-pf-type="Layout"]>div:first-child', init, 50, 15000);
      }
    } catch (e) {
      if (debug) console.log(e, "error in Test" + variation_name);
    }
  })();